const primaryMain = '#154734';
const primaryMainOpacity = 'rgba(21, 71, 52, 0.9)';
const secondaryMain = '#FEDB00';
const secondaryMainOpacity = 'rgba(254, 219, 0, 0.5)';
const secondaryLight = '#1f6d50';
const tertiaryMain = '#f8de3f';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
